module.exports = __webpack_public_path__ + "media/images/hp_quiz/favicon-eadcc520e26ec22c857a42408d374882.png";